import { formControl } from '@al00x/forms';
import { Component } from '@angular/core';
import {
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  formBuilder,
  CacFormBuilderComponent,
} from '@controladad/ng-base';

export type ConflictDialogData = any;
export type ConflictDialogResult = boolean;

@Component({
  selector: 'app-conflict-dialog',
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent],
  templateUrl: './conflict-dialog.component.html',
  styleUrl: './conflict-dialog.component.scss',
})
export class ConflictDialogComponent extends CacBaseDialogComponent<ConflictDialogData, ConflictDialogResult> {
  formBuilder = formBuilder({
    cols: 1,
    inputs: {
      conflict: {
        control: formControl<string>(undefined),
        label: this.data.field,
        type: 'radio',
        class: 'conflict-control',
        items: this.data.values,
      },
    },
  });

  onSubmit() {
    const conflict = this.formBuilder.getValue()?.conflict;
    if (!conflict) {
      snackbar$.error('لطفا یک مقدار را انتخاب کنید');
      return;
    }
    this.submit(true);
  }
}
